'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dIdentifier$0024$0024anon$0024168 from "./presto.types$-Account-Identifier$$anon$168.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AccountIdentifier$() {
  this.c3j = null;
  this.c3k = false;
  this.c3l = null;
  this.c3m = false;
}
export { $c_Lpresto_types$AccountIdentifier$ as $c_Lpresto_types$AccountIdentifier$ };
$p = $c_Lpresto_types$AccountIdentifier$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AccountIdentifier$;
/** @constructor */
function $h_Lpresto_types$AccountIdentifier$() {
}
export { $h_Lpresto_types$AccountIdentifier$ as $h_Lpresto_types$AccountIdentifier$ };
$h_Lpresto_types$AccountIdentifier$.prototype = $p;
$p.cHk = (function() {
  if ((!this.c3k)) {
    this.c3j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c3k = true;
  }
  return this.c3j;
});
$p.cIj = (function() {
  if ((!this.c3m)) {
    this.c3l = new $j_presto$002etypes$0024$002dAccount$002dIdentifier$0024$0024anon$0024168.$c_Lpresto_types$AccountIdentifier$$anon$168(this);
    this.c3m = true;
  }
  return this.c3l;
});
var $d_Lpresto_types$AccountIdentifier$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AccountIdentifier$, "presto.types$AccountIdentifier$", ({
  YM: 1,
  D: 1
}));
export { $d_Lpresto_types$AccountIdentifier$ as $d_Lpresto_types$AccountIdentifier$ };
var $n_Lpresto_types$AccountIdentifier$;
function $m_Lpresto_types$AccountIdentifier$() {
  if ((!$n_Lpresto_types$AccountIdentifier$)) {
    $n_Lpresto_types$AccountIdentifier$ = new $c_Lpresto_types$AccountIdentifier$();
  }
  return $n_Lpresto_types$AccountIdentifier$;
}
export { $m_Lpresto_types$AccountIdentifier$ as $m_Lpresto_types$AccountIdentifier$ };
//# sourceMappingURL=presto.types$-Account-Identifier$.js.map
